module.exports = __webpack_public_path__ + "img/lonAssemblageSmall.0021adbc.jpg";